<h3>{{ 'LABEL_INITIALISE_STANDALONE_MODE_DATA' | translate }}</h3>

<hr class="customized-border">

<div class="row">
  <div class="col">
    <div class="d-flex align-items-center">
      {{ 'LABEL_PLEASE_WAIT' | translate }}
      <i class="pi pi-spin pi-spinner m-2" style="font-size: 1.5rem;"></i>
    </div>
  </div>
</div>
